import React from "react";
import { Box } from "@mui/material";
import JumboIconButton from "@jumbo/components/JumboIconButton";
import CancelIcon from "@mui/icons-material/Cancel";

const ResetButton = ({ onReset }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        marginX: 1,
        marginY: 1,
      }}
    >
      <JumboIconButton
        onClick={onReset}
        color="error"
        sx={{ fontSize: "x-small" }}
        size="small"
        tooltip="Reset"
        tooltipPlacement="top"
      >
        <CancelIcon />
      </JumboIconButton>
    </Box>
  );
};

export default ResetButton;
